export default __webpack_public_path__ + "static/media/clock.98799c64.png";